import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["ballotId", "accessKey", "qrCode", "confirmationBallotCode", "confirmationUserName", "judgeWarning", "onsiteStart", "onsiteEnd"]
  static values = { electionId: Number, canShowAccessKey: Boolean, onsiteStart: String, onsiteEnd: String, isElectionJudge: Boolean, onsiteVotingActive: Boolean }

  connect() {
    const accessKeyModalElement = document.getElementById('accessKeyModal')
    this.accessKeyModal = new Modal(accessKeyModalElement)

    const confirmationModalElement = document.getElementById('confirmationModal')
    this.confirmationModal = new Modal(confirmationModalElement)

    const moreInfoModalElement = document.getElementById('moreInfoModal')
    this.moreInfoModal = new Modal(moreInfoModalElement)
  }

  confirmShowAccessKey(event) {
    event.preventDefault()
    this.currentBallotId = event.currentTarget.dataset.ballotId
    const ballotCode = event.currentTarget.dataset.ballotCode
    const userName = event.currentTarget.dataset.userName

    // Set ballot ID and user name in confirmation modal
    this.confirmationBallotCodeTarget.textContent = ballotCode
    this.confirmationUserNameTarget.textContent = userName

    // Show judge warning if user is election judge and onsite voting is not active
    if (this.isElectionJudgeValue && !this.onsiteVotingActiveValue) {
      this.judgeWarningTarget.style.display = 'block'
    } else {
      this.judgeWarningTarget.style.display = 'none'
    }

    // Show confirmation modal
    this.confirmationModal.show()
  }

  showMoreInfo(event) {
    event.preventDefault()

    // Set onsite voting times in the modal
    this.onsiteStartTarget.textContent = this.onsiteStartValue
    this.onsiteEndTarget.textContent = this.onsiteEndValue

    // Show more info modal
    this.moreInfoModal.show()
  }

  showAccessKey(event) {
    event.preventDefault()

    // Hide confirmation modal
    this.confirmationModal.hide()

    // Show loading state
    this.ballotIdTarget.textContent = 'Loading...'
    this.accessKeyTarget.textContent = 'Loading...'
    this.qrCodeTarget.src = ''
    this.accessKeyModal.show()

    // Make AJAX request to get access key
    fetch(`/admin/elections/${this.electionIdValue}/election_ballots/${this.currentBallotId}/show_access_key.json`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch access key')
        }
        return response.json()
      })
      .then(data => {
        this.ballotIdTarget.textContent = data.ballot_id
        this.accessKeyTarget.textContent = data.access_key
        this.qrCodeTarget.src = data.qr_code_data_url
      })
      .catch(error => {
        console.error('Error:', error)
        this.ballotIdTarget.textContent = 'Error loading data'
        this.accessKeyTarget.textContent = 'Error loading data'
        this.qrCodeTarget.src = ''
      })
  }

}
